import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { css } from "styled-components";
import { CloseSmallIcon } from './utils/IconFactory';
import { FadeIn } from "./utils";
export default React.memo(function CommonPopup({ icon, title, children, footer, onClose, className = '' }) {
    return (_jsx(OverLay, { className: `${className} ui-common-popup`, visible: true, children: _jsxs(CommonPopupContainer, { children: [_jsxs(Header, { children: [icon && _jsx("div", { className: "icon-container", children: icon }), _jsx("div", { className: "title-container", children: title }), _jsx("div", { className: "controls-container", onClick: onClose, children: _jsx(CloseSmallIcon, {}) })] }), _jsx("main", { children: children }), footer && _jsx(Footer, { children: footer })] }) }));
});
const OverLay = styled.div `
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;

  justify-content: center;
  align-items: center;

  background: var(--ui-overlay-color);

  ${p => !p.visible && css `
    background: transparent;
    pointer-events: none;
  `}
`;
const CommonPopupContainer = styled.section `
  display: block;
  position: absolute;
  box-sizing: border-box;
  min-width: 20rem;
  min-height: 20rem;
  padding: 1.125rem;
  background-color: var(--ui-popup-bg-color);
  box-shadow: var(--ui-box-shadow);
  border-radius: 0.5rem;

  animation: ${FadeIn} 0.2s ease-in-out;
`;
const Header = styled.header `
  display: flex;
  padding-bottom: 0.938rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid var(--ui-input-border-color);

  .icon-container {
    position: relative;
    margin-right: 0.688rem;

    & svg {
      width: 1.5rem;
      height: 1.5rem;
      vertical-align: middle;
    }
  }

  .title-container {
    display: flex;
    align-items: center;
    font-size: 1.125rem;
    font-weight: 600;
  }

  .controls-container {
    position: relative;
    margin-left: auto;
    cursor: pointer;

    & svg {
      width: 1.5rem;
      height: 1.5rem;
      vertical-align: middle;
    }
  }
`;
const Footer = styled.footer `
  position: relative;
  margin-top: 1.5rem;
`;
